import React from 'react'
import Style from '../mappingUi.module.css'

/** Card header shared by the mapping tabs: title, count chip and the submit button. */
const MappingHeader = ({ title, countLabel, isSaving, isDisabled, onSubmit }) => (
    <div className={`card-header p-10 ${Style.header}`}>
        <div className={Style.headerTitle}>
            <span>{title}</span>
            {countLabel ? <span className={Style.countChip}>{countLabel}</span> : null}
        </div>
        <button
            type="button"
            className={Style.submitButton}
            disabled={isDisabled || isSaving}
            onClick={onSubmit}
        >
            {isSaving ? <span className={Style.buttonSpinner} aria-hidden="true" /> : null}
            {isSaving ? 'Saving...' : 'Submit Mappings'}
        </button>
    </div>
)

export default MappingHeader
